import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PageTitle from 'components/UI/PageTitle';
import type React from 'react';

import ConversationEvals from '../ConversationEvals';

const Labs: React.FC = () => {
  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, pt: 2 }}>
        <PageTitle>Labs</PageTitle>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            color: 'text.secondary',
          }}
        >
          Herramientas experimentales para evaluación y análisis
        </Typography>
      </Box>
      <Box sx={{ py: 3 }}>
        <ConversationEvals />
      </Box>
    </Box>
  );
};

export default Labs;
